import React, { useState } from 'react'
import { Box } from '../../../../../../../../Components/CustomUi/box'
import { ContainerAnalises } from './styled'
import { HeaderAnalises } from './components/headerAnalises'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'
import { ListarAnalises } from './components/listarAnalises'
import { AnimatePresence, motion } from 'framer-motion'
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import { LabAnaliseItens } from '../../../../../../../../services/LabAnalise'
import { GeoPointFeature } from './components/headerAnalises/components/modalNovaAnalise'
import { PropsAnalisesCadastradas } from '../../../..'

interface PropsAnalises {
  setLoadingShape: React.Dispatch<React.SetStateAction<boolean>>
  malha: any
  setMalha: React.Dispatch<React.SetStateAction<any[]>>
  malhaShp: any[]
  setMalhaShp: React.Dispatch<React.SetStateAction<any[]>>
  tipo_analise_selecionada: string
  setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
  tipo_analise_selecionada_id: number
  setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  pontos_selecionados: GeoPointFeature[]
  setPontos_selecionados: React.Dispatch<React.SetStateAction<GeoPointFeature[]>>
  pontos_selecionados_adicionados: PropsAnalisesCadastradas[]
  setPontos_selecionados_adicionados: React.Dispatch<
    React.SetStateAction<
      { pontos_selecionados: GeoPointFeature[]; profundidade: string; analise_nome: string }[]
    >
  >
  talhaoArea: string
  setTalhaoArea: React.Dispatch<React.SetStateAction<string>>
  talhaoKml: any[]
  setTalhaoKml: React.Dispatch<React.SetStateAction<any[]>>
  open_loading_analise_lab: boolean
  grupoAnalises: LabAnaliseItens[]
  analises: {
    cod_analise: number
    cor: string
    pontos_selecionados: GeoPointFeature[]
    profundidade: string
    analise_nome: string
    valor: string
  }[]
  setAnalises: React.Dispatch<React.SetStateAction<any[]>>
  pontosTotalMalha: number
  setPontosTotalMalha: React.Dispatch<React.SetStateAction<number>>
  propriedade_area: string
  amostra: string
}

export const Analises: React.FC<PropsAnalises> = ({
  setLoadingShape,
  malha,
  setMalha,
  malhaShp,
  setMalhaShp,
  tipo_analise_selecionada,
  setTipo_analise_selecionada,
  tipo_analise_selecionada_id,
  setTipo_analise_selecionada_id,
  pontos_selecionados,
  setPontos_selecionados,
  pontos_selecionados_adicionados,
  setPontos_selecionados_adicionados,
  talhaoArea,
  setTalhaoArea,
  talhaoKml,
  setTalhaoKml,
  open_loading_analise_lab,
  grupoAnalises,
  analises,
  setAnalises,
  pontosTotalMalha,
  setPontosTotalMalha,
  amostra,
  propriedade_area,
}) => {
  const [abrirModalNova, setAbrirModalNova] = useState<boolean>(false)
  const [id, setId] = useState<string | number>(null)

  const [cor, setCor] = useState<string>('')

  const grupoAnalisesTratado = grupoAnalises?.map((item) => {
    return {
      ...item,

      analise_profundidade_nome: `(${item?.profundidade_nome}) | ${item?.analise_nome}`,
    }
  })

  const calcularTotalAnalises = (lista: any[]): number => {
    const total = lista.reduce((acumulador, item) => {
      if (!item?.valor_analise) return acumulador

      const valorLimpo = item?.valor_analise.replace(/[^\d,-]/g, '').replace(',', '.')

      const val = parseFloat(valorLimpo)

      return acumulador + (isNaN(val) || !isFinite(val) ? 0 : val)
    }, 0)

    return total
  }

  function inserirPontosSelecionados(pontos, id, cod_analise) {
    const filterAnalise = grupoAnalisesTratado?.filter((item) => item?.cod_analise === cod_analise)
    setTipo_analise_selecionada(filterAnalise[0]?.analise_profundidade_nome)
    setTipo_analise_selecionada_id(filterAnalise[0]?.cod_analise)
    setCor(filterAnalise[0]?.cor)
    setId(id)
    setPontos_selecionados(pontos)
    setAbrirModalNova(true)
  }

  function removerPonto(analiseId: string | number, pontoNome: number | string) {
    // Remove o ponto do array de análises (somente pontos_selecionados)
    setAnalises((prev) =>
      prev.map((analise) => {
        if (analise.id === analiseId) {
          const novosPontos = analise.pontos_selecionados.filter(
            (p: GeoPointFeature) => p.NOME !== pontoNome
          )

          // Recalcula o valor da análise
          const valorUnitario = Number(analise.valor) || 0
          const novoValor = (valorUnitario * novosPontos.length).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })

          return {
            ...analise,
            pontos_selecionados: novosPontos,
            valor_analise: novoValor,
          }
        }
        return analise
      })
    )
  }

  return (
    <ContainerAnalises>
      <Box gap={10} style={{ width: '100%' }} padding={15}>
        <h3>Análises</h3>
        <HeaderAnalises
          abrirModalNova={abrirModalNova}
          setAbrirModalNova={setAbrirModalNova}
          setLoadingShape={setLoadingShape}
          malha={malha}
          setMalha={setMalha}
          malhaShp={malhaShp}
          setMalhaShp={setMalhaShp}
          tipo_analise_selecionada={tipo_analise_selecionada}
          setTipo_analise_selecionada={setTipo_analise_selecionada}
          tipo_analise_selecionada_id={tipo_analise_selecionada_id}
          setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
          pontos_selecionados={pontos_selecionados}
          setPontos_selecionados={setPontos_selecionados}
          pontos_selecionados_adicionados={pontos_selecionados_adicionados}
          setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
          pontosTotalMalha={pontosTotalMalha}
          setPontosTotalMalha={setPontosTotalMalha}
          talhaoArea={talhaoArea}
          setTalhaoArea={setTalhaoArea}
          talhaoKml={talhaoKml}
          setTalhaoKml={setTalhaoKml}
          grupoAnalises={grupoAnalises}
          analises={analises}
          setAnalises={setAnalises}
          id={id}
          setId={setId}
          cor={cor}
          setCor={setCor}
          grupoAnalisesTratado={grupoAnalisesTratado} />
        <LineDivider />
        <ListarAnalises
          analises={analises}
          grupoAnalises={grupoAnalises}
          pontos={pontosTotalMalha}
          talhaoArea={talhaoArea}
          amostra={amostra}
          propriedade_area={propriedade_area}
          inserirPontosSelecionados={inserirPontosSelecionados}
          copiarAnalise={undefined}
          removerPonto={removerPonto}
          setAnalises={setAnalises}
        />
      </Box>
      <div className='footer__analises'>
        <div className='detalhes'>
          <span style={{ color: '#7B7B7B', fontSize: '13px', fontWeight: '500' }}>
            Total de amostras
          </span>
          <strong>
            {analises.reduce((acc, item) => acc + (item.pontos_selecionados?.length || 0), 0)}
          </strong>
        </div>
        <div className='detalhes'>
          <span style={{ color: '#7B7B7B', fontSize: '13px', fontWeight: '500' }}>
            Grid Amostral
          </span>
          <strong>
            {pontosTotalMalha > 0 ? (parseFloat(talhaoArea) / pontosTotalMalha).toFixed(2) : '0.00'}
          </strong>
        </div>
        <div className='detalhes'>
          <span style={{ color: '#7B7B7B', fontSize: '13px', fontWeight: '500' }}>R$ por ha</span>
          <strong>
            {(() => {
              const totalVal = calcularTotalAnalises(analises)
              const areaVal = parseFloat(talhaoArea)
              if (!totalVal || !areaVal || areaVal <= 0 || !isFinite(areaVal)) {
                return (0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })
              }
              return (totalVal / areaVal).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            })()}
          </strong>
        </div>
        <div className='detalhes' data-active={true}>
          <span>Valor total</span>
          <strong>
            {calcularTotalAnalises(analises)?.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </strong>
        </div>
      </div>
      <AnimatePresence>
        {open_loading_analise_lab && (
          <motion.div
            className='overlay_loading_lab'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Carregando
              animation
              legenda='Buscando análises do laboratório...'
              justifyContent='center'
            />
          </motion.div>
        )}
      </AnimatePresence>
    </ContainerAnalises>
  )
}
